import { cn } from '@/lib/cn';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const DialogHeader = ({ children, className }: Props) => {
  return (
    <div className={cn('flex flex-col gap-3 p-7 pb-6', className)}>
      {children}
    </div>
  );
};

export default DialogHeader;
